<div class="credit-result-pismo-contracts">
    <div class="row">
        <div class="col-12">
            @if (hasError) {
                <div class="mb-4">
                    <message-box type="warn">Unable to load PISMO contracts</message-box>
                </div>
            } @else {
                <div [ngClass]="{hidden: (loader.tableLoading.inProgress$ | async), 'table-section': true}">
                    <table mat-table [dataSource]="dataSource" class="width-100 mb-4">
                        @for (column of columnsToDisplay; track column) {
                            <ng-container matColumnDef="{{column}}">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="cell">{{getColumnTitle(column)}}</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="cell">
                                        @switch (column) {
                                            @case ('pismoAccountNumber') {
                                                @if (element.pismoAccountNumber != null) {
                                                    <a class="clickable" (click)="onClickAccount(element.pismoAccountNumber)">
                                                        {{element.pismoAccountNumber}}
                                                    </a>
                                                } @else {
                                                    -
                                                }
                                            }
                                            @case ('totalLimit') {
                                                @if (element.totalLimit != null) {
                                                    {{element.totalLimit | looseCurrency}}
                                                } @else { - }
                                            }
                                            @case ('currentBalance') {
                                                @if (element.currentBalance != null) {
                                                    {{element.currentBalance | looseCurrency}}
                                                } @else { - }
                                            }
                                            @case ('currentUtilisationPct') {
                                                @if (element.currentUtilisationPct != null) {
                                                    {{element.currentUtilisationPct | number:'1.0-2'}}%
                                                } @else { - }
                                            }
                                            @case ('amortisation') {
                                                {{element.amortisation ? 'Yes' : 'No'}}
                                            }
                                            @case ('creationDate') {
                                                @if (element.creationDate) {
                                                    {{element.creationDate | date:'dd/MM/yyyy'}}
                                                } @else { - }
                                            }
                                            @case ('dishonourCountL12m') {
                                                {{element.dishonourCountL12m ?? 0}}
                                            }
                                            @default {
                                                {{element[column] ?? '-'}}
                                            }
                                        }
                                    </div>
                                </td>
                            </ng-container>
                        }

                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
                        </tr>
                    </table>

                    @if (!dataSource.length && !(loader.tableLoading.inProgress$ | async)) {
                        <table>
                            <tr>
                                <td class="not-found">No PISMO contracts found</td>
                            </tr>
                        </table>
                    }
                </div>
            }
        </div>
    </div>
</div>
